export default __webpack_public_path__ + "static/media/plain-sticker-tr.92b60a42.png";